module.exports = __webpack_public_path__ + "static/media/great-idea.f16ea8fd.svg";